import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';

export class HistoriqueDpap {
    static jsonMap = {
        idOperateur: { key: 'idOperateur' },
        idDeclaration: { key: 'idDeclaration' },
        idCahier: { key: 'idCahier' },
        libelleCahier: { key: 'libelleCahier', optional: true, default: '' },
        date: { key: 'date', converter: new DateConverter(), optional: true },
        campagne: { key: 'campagne', optional: true, default: '' },
        surfaceEngagee: { key: 'surfaceEngagee', optional: true },
        surfacePlantee: { key: 'surfacePlantee', optional: true }
    };

    idOperateur: number;
    idDeclaration: number;
    idCahier: number;
    libelleCahier: string;
    date: moment.Moment;
    campagne: string;
    surfaceEngagee: number;
    surfacePlantee: number;
}
